<template>
	<div class="modal fade" tabindex="-1" role="dialog" :aria-labelledby="modalName +'-title'">
		<div class="modal-dialog">
			<div class="modal-content">

				<div class="modal-header">
					<h4 class="modal-title" :id="modalName +'-title'">{{titleText}}</h4>
					<button type="button" class="close" aria-label="Close" @click="cancelModal"><span aria-hidden="true">&times;</span></button>
				</div>
				<div class="modal-body">
					<slot></slot>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-outline-primary" @click="confirmModal">{{confirmText}}</button>
					<button type="button" class="btn btn-outline-primary" @click="cancelModal">{{cancelText}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import store from '../state'

	export default {
		name: 'Modal',
		props: ['modalId','title','confirm', 'cancel', 'visible'],
		data() {
			return {
				modalName: this.modalId || 'myModal',
				titleText: this.title || 'Confirm',
				confirmText: this.confirm || 'Ok',
				cancelText: this.cancel || 'Cancel',
			}
		},
		methods: {
			confirmModal() {
				this.$emit('confirm');
			},
			cancelModal() {
				this.$emit('cancel');
			}
		},
		watch: {
			visible(value) {
				const self = this;

				//Show the modal
				if (value) {
					jQuery(this.$el).modal({show: true, focus: true});

					//Detect when the modal has finished hide animation
					jQuery(this.$el).on("hidden.bs.modal", function() {

						//If the dialog was triggered by clicking outside the modal, then 
						self.cancelModal();
						
					});
				} 
				else {
					jQuery(this.$el).modal('hide');
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Modal.vue